/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageAccountDetailsForAzureCspMaster {
    getFixupPrototypeFunction() { return StorageAccountDetailsForAzureCspMaster.fixupPrototype; }

    static newInstance(model: Partial<StorageAccountDetailsForAzureCspMaster>): StorageAccountDetailsForAzureCspMaster {
        let obj = Object.assign(new StorageAccountDetailsForAzureCspMaster(), model);
        StorageAccountDetailsForAzureCspMaster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageAccountDetailsForAzureCspMaster>): StorageAccountDetailsForAzureCspMaster {
        if (!model) return null;
        return StorageAccountDetailsForAzureCspMaster.newInstance(<StorageAccountDetailsForAzureCspMaster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageAccountDetailsForAzureCspMaster) {
        if (!obj) return;

        models.StorageAccountDetailsForAzureCspMaster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageAccountDetailsForAzureCspMaster): boolean {
        Object.setPrototypeOf(obj, StorageAccountDetailsForAzureCspMaster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Storage account subscription Id.
     */
    subscription_id: string;

    /**
     * Storage Account name
     */
    name: string;

    /**
     * Cost Report Path.
     */
    report_path: string;

}
